// import React from 'react'
import { compose } from 'redux'

// containers
import withMutation from './withMutation'
import withFormLogic from './withFormLogic'
import withRedux from './withRedux'

// presentational component
import AdminClearCache from 'components/AdminClearCache'

export default compose(
  withMutation,
  withFormLogic,
  withRedux
)(AdminClearCache)
